const TRACK_FILTERS = ["all", "operator", "engineer", "hunter", "leader"];

export default function TrackFilter({ value, onChange }) {
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {TRACK_FILTERS.map((t) => (
        <button
          key={t}
          onClick={() => onChange(t)}
          data-testid={`squad-filter-${t}`}
          className={`font-mono text-xs px-3 py-1 border uppercase tracking-widest ${
            value === t
              ? "bg-[var(--cyan)] text-[var(--bg)] border-[var(--cyan)]"
              : "border-[var(--border)] text-[var(--text-2)] hover:border-[var(--cyan)] hover:text-[var(--cyan)]"
          }`}
        >
          {t}
        </button>
      ))}
    </div>
  );
}
